<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4 class="card-title">CLIENTS</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="ClientForm">
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="Database Name" type="text" formControlName="database" (keypress)="preventSpace($event)">
                    <mat-error *ngIf="ClientForm.get('database').hasError('required')">
                      Database Name is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              
              <div class="row">
                <div class="col-md-5">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="Company Name" formControlName="companyname">
                    <mat-error *ngIf="ClientForm.get('companyname').hasError('required')">
                      Company Name is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-3">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="Username" formControlName="username">
                    <mat-error *ngIf="ClientForm.get('username').hasError('required')">
                      Username is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="Email address" type="email" formControlName="email" appLowercaseInput>
                    <mat-error *ngIf="ClientForm.get('email').hasError('email') && !ClientForm.get('email').hasError('required')">
                      Please enter a valid email address
                    </mat-error>
                    <mat-error *ngIf="ClientForm.get('email').hasError('required')">
                      Email is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="Address" type="text" formControlName="address">
                    <mat-error *ngIf="ClientForm.get('address').hasError('required')">
                      Address is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            
              <div class="row">
                <div class="col-md-6">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="City" type="text" formControlName="city">
                    <mat-error *ngIf="ClientForm.get('city').hasError('required')">
                      City is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-6">
                    <label>country <span style="color: red !important;">*</span></label>
                    <ng-select [items]="countries" bindLabel="name" bindValue="name" formControlName="country">
                    </ng-select>
                    <!-- <input matInput placeholder="Country" type="text" formControlName="country"> -->

                    <mat-error *ngIf="ClientForm.get('country').invalid && (ClientForm.get('country').dirty || ClientForm.get('country').touched)">
                      country is <strong>required</strong>
                    </mat-error>

              
                </div>
              </div>
            
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field class="example-full-width">
                    <input type="date" matInput placeholder="Expire Date" formControlName="expiredate">
                    <mat-error *ngIf="ClientForm.get('expiredate').hasError('required')">
                      Expire Date is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            
              <div class="row">
                <div class="col-md-6">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="Paid" type="number" formControlName="paid">
                    <mat-error *ngIf="ClientForm.get('paid').hasError('required')">
                      Paid value is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-6">
                  <mat-form-field>
                    <mat-label>Type</mat-label>
                    <select matNativeControl required formControlName="type">
                      <option value="Retail">Retail</option>
                      <option value="Restaurant">Restaurant</option>
                      <option value="Hotel">Hotel</option>
                    </select>
                    <mat-error *ngIf="ClientForm.get('type').hasError('required')">
                      Type is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            
              <div class="row">
                <div class="col-md-6">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="Phone Number" type="text" formControlName="phonenumber">
                    <mat-error *ngIf="ClientForm.get('phonenumber').hasError('required')">
                      Phone Number is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            
              <div class="row">
                <div class="col-md-6">
                  <div class="file btn btn-lg primary mt-4">
                    <input type="file" accept="image/*" (change)="onFileSelected($event)" required />
                  </div>
                </div>
                <div class="col-md-6">
                  <label>Packages <span style="color: red !important;">*</span></label>
                  <ng-select [items]="packages" bindLabel="Name" bindValue="id" formControlName="package" (change)="getcatbypackage($event)">
                  </ng-select>
                  <mat-error *ngIf="ClientForm.get('package').invalid && (ClientForm.get('package').dirty || ClientForm.get('package').touched)">
                    Package is <strong>required</strong>
                  </mat-error>
                </div>
              </div>
            
              <div class="row">
                <div class="col-md-4">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="Branches Count" type="number" formControlName="branches" [readonly]="pakageReadOnly">
                    <mat-error *ngIf="ClientForm.get('branches').hasError('required')">
                      Branches Count is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="Users Count" type="number" formControlName="users" [readonly]="pakageReadOnly">
                    <mat-error *ngIf="ClientForm.get('users').hasError('required')">
                      Users Count is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="Audits Count" type="number" formControlName="audits" [readonly]="pakageReadOnly">
                    <mat-error *ngIf="ClientForm.get('audits').hasError('required')">
                      Audits Count is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            
              <div class="row">
                <div class="col-md-8">
                  <label class="form-label">Module <span style="color: red !important;">*</span></label>
                  <ng-select [items]="modules" [multiple]="true" bindLabel="name" bindValue="id" formControlName="module">
                  </ng-select>

                  <mat-error *ngIf="ClientForm.get('module').invalid && (ClientForm.get('module').dirty || ClientForm.get('module').touched)">
                    Module is <strong>required</strong>
                  </mat-error>
                </div>
              </div>
            
              <!-- <button mat-raised-button type="submit" [disabled]="ClientForm.invalid" (click)="executeClientOperations()">Add Client</button> -->

              <button mat-raised-button type="submit" *ngIf="!editmode" class="btn primary pull-right" [disabled]="ClientForm.invalid" (click)="addclient()">Add Client</button>

              

                                    
  <button mat-raised-button type="submit" *ngIf="editmode" class="btn primary pull-right" [disabled]="ClientForm.invalid" (click)="editclientanotherdb()">Save</button>

            </form>
           
            <mat-form-field class="mt-5">
              <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
            </mat-form-field>

            <table mat-table [dataSource]="clients" class="mat-elevation-z8">

              <!-- Position Column -->
              <ng-container matColumnDef="companyname">
                <th mat-header-cell *matHeaderCellDef> company name </th>
                <td mat-cell *matCellDef="let element"> {{element.companyname}} </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef> email </th>
                <td mat-cell *matCellDef="let element"> {{element.email}} </td>
              </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef> type </th>
                <td mat-cell *matCellDef="let element"> {{element.type}} </td>
              </ng-container>


              <ng-container matColumnDef="expiredate">
                <th mat-header-cell *matHeaderCellDef> expire date </th>
                <td mat-cell *matCellDef="let element"> {{element.expiredate | date:'yyyy-MM-dd'}} </td>
              </ng-container>





              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let element">
                  <button mat-raised-button (click)="edit(element)"><i class="material-icons">
                      edit
                    </i></button>
                  <button mat-raised-button (click)="delete(element)"><i class="material-icons">
                      delete
                    </i></button>
                  <button mat-raised-button (click)="gotoclient(element)"><i class="material-icons">
                      play_arrow
                    </i></button>
                    
             
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>